/**
 * フィルターリセット
 */

jQuery( function ($) {
	$('.js-filter-reset').on('click', function() {
		$('#filter input[type="checkbox"]').prop('checked', false);
	});
} );